import ajax from '@/utils/ajax';

const head = '/web';

// 新课堂热搜词
export const reqNewHotWord = (terminal, terrace) => ajax(`${head}/v1/hot/list-now?terminal=${terminal}&terrace=${terrace}`);

// 新课堂热搜词点击量
export const reqHotClick = (id) => ajax(`${head}/v1/hot/hit/${id}`, '', 'PUT');

// 搜索列表 h5-ark
// export const reqSearchList = (endPoint, pageNum, productName) => ajax(`${head}/v1/h5/product/home/search?endPoint=${endPoint}&isShow=1&pageNum=${pageNum}&pageSize=10&platform=1&productName=${productName}`);
// export const reqSearchList = (productName, endPoint) => ajax(`${head}/v1/product/home/search?productName=${productName}&endPoint=${endPoint}&platform=1`);

// 搜索列表新
export const reqSearchListNew = (endPoint, pageNum, goodsName) => ajax(`${head}/v1/goods-search/h5/search?endPoint=${endPoint}&isShow=1&pageNum=${pageNum}&pageSize=10&goodsName=${goodsName}`, '', 'POST');
